import React, { useState } from "react";
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

export default function ExpirationYearInput({ value, onSubmit, disabled }) {
  const [open, setOpen] = useState(true);
  const [datePickerValue, setDatePickerValue] = useState(value);
  const [lastView, setLastView] = useState(null);

  const handleChange = (date, view) => {
    const newValue = date ? moment(date).format("YYYY") : "";
    setDatePickerValue(newValue);

    if (date && lastView === "year") {
      onSubmit(newValue);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        label="Expiration Year"
        views={["year"]}
        open={open}
        onOpen={() => setOpen(true)}
        disabled={disabled}
        value={datePickerValue ? moment(datePickerValue, "YYYY") : null}
        onChange={handleChange}
        onViewChange={view => setLastView(view)}
        format="YYYY"
        slotProps={{
          textField: {
            fullWidth: true,
            size: "small",
            onClick: () => setOpen(true),
            onKeyDown: e => e.preventDefault(),
          },
        }}
      />
    </LocalizationProvider>
  );
} 